export default __webpack_public_path__ + "media/color/eon-3a24de62.svg";